import React from 'react';
import { notification } from 'antd';
import { CheckCircleTwoTone, ExclamationCircleTwoTone } from '@ant-design/icons';

const DEFAULT_SUCCESS_TITLE = '成功';
const DEFAULT_ERROR_TITLE = '失敗';
const DEFAULT_SUCCESS_DESCRIPTION = 'あなたの行動は成功しています。';
const DEFAULT_ERROR_DESCRIPTION = '何か問題が起こりました。';

export const openSuccessNoti = (data?: { title?: string; description?: string }) => {
    notification.open({
        duration: 2,
        icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
        message: data?.title ?? DEFAULT_SUCCESS_TITLE,
        description: data?.description ?? DEFAULT_SUCCESS_DESCRIPTION,
    });
};

export const openErrorNoti = (data?: { title?: string; description?: string }) => {
    // notification.open({
    //     duration: 2,
    //     icon: <ExclamationCircleTwoTone twoToneColor="#f81d22" />,
    //     message: data?.title ?? DEFAULT_ERROR_TITLE,
    //     description: data?.description ?? DEFAULT_ERROR_DESCRIPTION,
    // });
    console.log("error")
};
